import { I18n } from "../services/I18n";
import "./generated/site-translations-sr";
import common_sr from "../../../../../libs/ps/restaumatic-common/locales/sr.json";
import core_types_sites_sr from "../../../../../libs/ps/restaumatic-core-types-sites/locales/sr.json";
I18n.translations = I18n.translations || {};
I18n.translations = I18n.extend(I18n.translations, {
  sr: { _core_types_sites: core_types_sites_sr },
});
I18n.translations = I18n.extend(I18n.translations, {
  sr: { _common: common_sr },
});
